import { ErrorAlert } from "components/atoms/Alert"
import { Button, LinkButton, SecondaryButton } from "components/atoms/Button"
import { PageTitle } from "components/atoms/PageTitle"
import {
  AuthForm,
  FormEmailInput,
  AuthFormItem,
  FormPasswordInput,
} from "components/atoms/form"
import { FirebaseError } from "firebase/app"
import { useInitializeAccountData } from "hooks/useInitializeAccountData"
import { useAsyncLoading } from "hooks/useLoading"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import styled from "styled-components"
import {
  firebaseError,
  logInWithEmailAndPassword,
  signOut,
} from "usecases/firebase/auth"

import { useReloadFirebaseAuth } from "../../hooks/useFirebaseAuth"
import { firebaseUserState } from "../../recoils/firebaseUserState"

import type { LogInFormIF } from "interfaces/LogInFormIF"

const StyledButton = styled(Button)`
  min-width: 6rem;
`
const StyledSecondaryButton = styled(SecondaryButton)`
  min-width: 6rem;
`
export const LogInPage: React.VFC = () => {
  const [error, setError] = useState("")
  const [loading, asyncLoading] = useAsyncLoading("auth")
  const [isLoading, setIsLoading] = useState(false)
  const initialize = useInitializeAccountData()
  const reloadUser = useReloadFirebaseAuth()
  const navigate = useNavigate()
  const user = useRecoilValue(firebaseUserState)

  const onFinish = async (values: unknown) => {
    setIsLoading(true)
    await asyncLoading(
      logInWithEmailAndPassword(
        (values as LogInFormIF).email,
        (values as LogInFormIF).password,
      )
        .then(async (cred) => {
          cred.user.getIdTokenResult().then(async (tokenResult) => {
            if (tokenResult.claims.isAdmin) {
              setIsLoading(false)
              signOut()
              throw new FirebaseError(
                "auth/is-admin",
                "メールアドレスまたはパスワードが違います",
              )
            } else {
              await reloadUser()
              await initialize()
              setIsLoading(false)
              if (user.emailVerified) {
                navigate("/")
              } else {
                navigate("/register/mail")
              }
            }
          })
        })
        .catch((e) => {
          const code = firebaseError(e.code, "signin")
          code && setError(code)
        }),
    )
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo)
  }

  return (
    <AuthForm onFinish={onFinish} onFinishFailed={onFinishFailed}>
      <PageTitle> 求人広告掲載企業様向け </PageTitle>

      <FormEmailInput />
      <FormPasswordInput />

      {error && <ErrorAlert>{error}</ErrorAlert>}

      <AuthFormItem>
        <StyledButton
          isLoading={loading || isLoading}
          className={"primary"}
          htmlType="submit"
        >
          ログイン
        </StyledButton>
      </AuthFormItem>

      <AuthFormItem>
        <StyledSecondaryButton
          onClick={() => {
            navigate("/register")
          }}
        >
          新規登録
        </StyledSecondaryButton>
      </AuthFormItem>

      <AuthFormItem>
        <LinkButton to="/forget">パスワード忘れた方はこちら</LinkButton>
      </AuthFormItem>
    </AuthForm>
  )
}
